// extracted by mini-css-extract-plugin
module.exports = {"drawer":"Drawer_drawer__YDNOR","primary":"Drawer_primary__tufmI","secondary":"Drawer_secondary__8sKYu","extra":"Drawer_extra__UcTSD","withoutRadius":"Drawer_withoutRadius__0If3J"};